module.exports = __webpack_public_path__ + "src/assets/img/cmd-go-arm.7102600d.svg";